import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import Espacios from "@/pages/Espacios";
import Menu from "@/pages/Menu";
import Contacto from "@/pages/Contacto";

/**
 * App Component
 * 
 * Configuración centralizada de rutas para el complejo turístico Las Gaviotas.
 * Implementa React Router para la navegación entre el inicio, espacios (restaurantes y cabañas),
 * menú gastronómico y contacto.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos de caché
      retry: 1,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            {/* Ruta Principal: Home */}
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />

            {/* Ruta de Espacios: Restaurantes y Cabañas */}
            <Route path={ROUTE_PATHS.ESPACIOS} element={<Espacios />} />

            {/* Ruta de Menú: Oferta Gastronómica */}
            <Route path={ROUTE_PATHS.MENU} element={<Menu />} />

            {/* Ruta de Contacto y Ubicación */}
            <Route path={ROUTE_PATHS.CONTACTO} element={<Contacto />} />

            {/* Catch-all: Redirección al Home para rutas no definidas */}
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>

        {/* Notificaciones globales (Toast y Sonner) */}
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;